import { render } from "./routeinformasipendaftaran.vue?vue&type=template&id=f8440bb2"
import script from "./routeinformasipendaftaran.vue?vue&type=script&lang=js"
export * from "./routeinformasipendaftaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__